@if (open) {
  <section class="consent-banner" role="region" aria-labelledby="consent-banner-title">
    <div class="consent-banner__panel">
      <div class="consent-banner__copy">
        <h2 id="consent-banner-title">Privacy choices</h2>
        <p>
          If you are in the EU or EEA, we record an IAB TCF v2.2 consent string and send it with ad requests
          from this dashboard. You can change these choices later from the account menu.
        </p>
      </div>

      @if (manage) {
        <ul class="consent-banner__purposes">
          @for (purpose of purposes; track purpose.key) {
            <li>
              <div>
                <strong>{{ purpose.label }}</strong>
                @if (purpose.description) {
                  <p>{{ purpose.description }}</p>
                }
              </div>
              <mat-slide-toggle
                color="primary"
                [checked]="choices[purpose.key]"
                [disabled]="saving"
                (change)="choices[purpose.key] = $event.checked">
                {{ choices[purpose.key] ? 'On' : 'Off' }}
              </mat-slide-toggle>
            </li>
          }
        </ul>
      }

      <div class="consent-banner__actions">
        @if (!manage) {
          <button type="button" mat-stroked-button [disabled]="saving" (click)="manage = true">Manage choices</button>
        }
        <button type="button" mat-stroked-button [disabled]="saving" (click)="rejectOptional()">Reject optional</button>
        @if (manage) {
          <button type="button" mat-flat-button color="primary" [disabled]="saving" (click)="saveChoices()">Save choices</button>
        } @else {
          <button type="button" mat-flat-button color="primary" [disabled]="saving" (click)="acceptAll()">Accept all</button>
        }
      </div>
    </div>
  </section>
}
